export const LinkData = [
  {
    id: 1,
    title: "Home",
    url: "/",
  },
  {
    id: 2,
    title: "About-Us",
    url: "/about",
  },
  {
    id: 3,
    title: "Services",
    url: "/courses",
  },
  {
    id: 4,
    title: "Staff",
    url: "/staff",
  },
  {
    id: 5,
    title: "Contact",
    url: "/contact",
  },
  {
    id: 6,
    title: "Career",
    url: "/blog",
  },
]
export const courses = [
  {
    id: 1,
    cover: "../images/care4.webp",
    title: "DOMICILIARY CARE",
  },
  {
    id: 2,
    cover: "../images/care1.jpg",
    title: "Daily Living SUPPORT",
  },
  {
    id: 3,
    cover: "../images/care2.jpg",
    title: "Community SUPPORT",
  },
  
  {
    id: 5,
    cover: "../images/care3.jpg",
    title: "HOSPITAL DISCHARGE SUPPORT",
  },
 
]
